<script lang="ts" generics="T extends string | number | null">
  import type { HTMLSelectAttributes } from 'svelte/elements';
  interface Option { value: T; label: string; disabled?: boolean }
  interface Props extends Omit<HTMLSelectAttributes, 'value'> {
    value?: T;
    options: Option[];
    placeholder?: string;
    onchange?: (event: Event & { currentTarget: HTMLSelectElement }) => void;
  }
  let { value = $bindable(), options, placeholder, class: cls = '', ...rest }: Props = $props();
</script>

<select class="control {cls}" bind:value {...rest}>
  {#if placeholder}<option value={null} disabled hidden>{placeholder}</option>{/if}
  {#each options as option (option.value)}
    <option value={option.value} disabled={option.disabled}>{option.label}</option>
  {/each}
</select>
